// Angular-Module
import {Injectable} from '@angular/core';
// ReactiveX for JavaScript
import {Observable} from 'rxjs';
// Globale Services
import {BackendService} from '@global/services/backend.service';

@Injectable({providedIn: 'root'})
export class InstitutionsEventsListService {
    /**
     * Konstruktor (inkl. dependency injection)
     * @param backendService
     */
    constructor(private backendService: BackendService) {}

    /**
     * Layouts über Backend laden
     */
    getLayoutData(): Observable<any> {
        // GET-Request über BackendService senden
        const getRequest$: Observable<any> = this.backendService.getRequest('Grid/getLayoutDatasets/institutionsEvents');
        // Observable (an Komponente) zurückliefern
        return getRequest$;
    }

    /**
     * Events für eine Institution laden
     * @param institutionId
     */
    loadInstitutionEvents(institutionId: number): Observable<any> {
        // GET-Request über BackendService senden
        const getRequest$: Observable<any> = this.backendService.getRequest('EventsData/getEventsByInstitution/' + institutionId);
        // Observable (an Komponente) zurückliefern
        return getRequest$;
    }
}